import {Chart as ChartJS, ChartConfiguration, ChartTypeRegistry, registerables} from 'chart.js';

export {MONTH_KEYS} from '@consts/date';

ChartJS.register(...registerables);

export const createChart = <TType extends keyof ChartTypeRegistry>(
    canvas: HTMLCanvasElement,
    config: ChartConfiguration<TType>,
) => new ChartJS(canvas, config);

export const VIOLATION_TYPES_BASE_COLORS: Record<
    string,
    {backgroundColor: string; borderColor: string}
> = {
    DECL_ABSENT_1: {
        backgroundColor: 'rgba(159, 184, 235, 0.3)',
        borderColor: '#9FB8EB',
    },
    DECL_INVOICE_DIFF_2: {
        backgroundColor: 'rgba(200, 255, 102, 0.3)',
        borderColor: '#C8FF66',
    },
    DECL_NOT_FULL_PAID_3: {
        backgroundColor: 'rgba(255, 87, 63, 0.2)',
        borderColor: '#FF573F',
    },
};

export const VIOLATION_TYPES_COLORS = [
    {backgroundColor: 'rgba(255, 234, 0, 0.3)', borderColor: '#FFEA00'},
    {backgroundColor: 'rgba(179, 157, 219, 0.3)', borderColor: '#B39DDB'},
    {backgroundColor: 'rgba(244, 143, 177, 0.3)', borderColor: '#F48FB1'},
    {backgroundColor: 'rgba(128, 222, 234, 0.3)', borderColor: '#80DEEA'},
    {backgroundColor: 'rgba(79, 121, 208, 0.3)', borderColor: '#4F79D0'},
    {backgroundColor: 'rgba(82, 203, 80, 0.3)', borderColor: '#52CB50'},
    {backgroundColor: 'rgba(175, 8, 8, 0.3)', borderColor: '#AF0808'},
    {backgroundColor: 'rgba(249, 168, 37, 0.3)', borderColor: '#F9A825'},
    {backgroundColor: 'rgba(81, 45, 168, 0.3)', borderColor: '#512DA8'},
    {backgroundColor: 'rgba(197, 17, 98, 0.3)', borderColor: '#C51162'},
    {backgroundColor: 'rgba(0, 151, 167, 0.3)', borderColor: '#0097A7'},
];

export const getLocalizedTitle = (item?: {title: Record<string, string> | null}, lang = 'en') =>
    item?.title?.[lang] ?? item?.title?.en ?? Object.values(item?.title ?? {})[0] ?? '';
